import React, { useEffect, useState } from 'react';
export const PulsingIcon = ({
  onClick
}) => {
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const interval = setInterval(() => {
      setScale(prev => prev === 1 ? 1.1 : 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative cursor-pointer" onClick={onClick} style={{
    transition: 'transform 0.7s ease-in-out',
    transform: `scale(${scale})`
  }} data-id="element-22">
      <div className="absolute inset-0 bg-red-600 rounded-full opacity-30 animate-ping" data-id="element-23"></div>
      <div className="relative z-10 w-32 h-32 bg-red-600 rounded-full flex items-center justify-center" data-id="element-24">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gNRTvMU15YCKgQXKm7xXDx/itchicon.png" alt="Itch icon" className="w-24 h-24 object-contain" data-id="element-25" />
      </div>
    </div>;
};